import React, {useEffect, useState} from "react";
import {Breadcrumb, Card, Col, Row} from "react-bootstrap";
import {isLoggedIn} from "../../common/utils";
import {useParams} from "react-router-dom";
import Container from "react-bootstrap/Container";
import ContactEntity from "../contact/contactEntity.component";
import ActsService from "../../services/acts.service";

const ActContact = () => {
    let {actId} = useParams();
    const [act, setAct] = useState()
    let loggedIn = isLoggedIn();

    const fetchAct = (actId) => {
        if (actId !== undefined) {
            ActsService.getActById(actId).then(
                response => {
                    setAct(response.data);
                    console.log("act:" + JSON.stringify(response.data));
                },
                error => {
                    console.log(error);
                });
        }
    }

    // load once on mount to fetch act
    useEffect(() => {
        fetchAct(actId);
    }, [act]); // eslint-disable-line react-hooks/exhaustive-deps

    if (act !== undefined) {
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col>
                            <h3>
                                <Breadcrumb>
                                    <Breadcrumb.Item active>Acts</Breadcrumb.Item>
                                    <Breadcrumb.Item active>{act.name}</Breadcrumb.Item>
                                </Breadcrumb>
                            </h3>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <h3 className="mb-3">
                                        Contact
                                    </h3>
                                    {loggedIn &&
                                        <div>
                                            <ContactEntity entityId={act.id} entityType={"act"} entityName={act.name}/>
                                        </div>
                                    }
                                    {!loggedIn &&
                                        <div>
                                            You need to be logged in to contact this act.
                                        </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
};

export default ActContact;